module.exports = __webpack_public_path__ + "static/img/shipinhuiyi.6c4f780.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom/blue/shipinhuiyi.png
// module id = KcCt
// module chunks = 24